module.exports = __webpack_public_path__ + "static/media/notification-student.9cb98c9f.svg";